import { createWireStore, selectQueryString } from '@oneappexchange/lwc-wired';
import { createRouterStore, selectUrl } from '@oneappexchange/lwc-wired-router';
import { initializeI18nLinks } from 'i18n/link';
import { initializePageLinks } from 'page/link';
import { IN_MAINTENANCE, IS_DEVELOPMENT, PUBLIC_URL } from '~/config';
import { scrollToTop } from '../utilities/browserUtilities';
import { logger } from '../utilities/logger';

// Add additional routes here
export const HOME_ROUTE = 'home';
export const LISTINGS_ROUTE = 'listings';
export const SOLUTIONS_ROUTE = 'solutions';
export const TRIAL_TEMPLATES_ROUTE = 'trial-templates';
export const ORGS_ROUTE = 'orgs';
export const LISTING_EDITOR_ROUTE = 'listing-editor';
export const SECURITY_REVIEW_EDITOR_ROUTE = 'security-review-editor';
export const PUBLISHER_ROUTE = 'publisher';
export const LOGGED_OUT_ROUTE = 'logged-out';
export const REPORT_ERROR_ROUTE = 'report-issue'; // TODO
export const ERROR_ROUTE = 'error';
export const COMMERCE_CALLBACK_ROUTE = 'commerce-callback';
export const ANALYTICS_ROUTE = 'analytics';
export const MAINTENANCE_ROUTE = 'inMaintenance';

// And connect them to a LWC component here
let routes;
if (!IN_MAINTENANCE) {
  routes = {
    '': () => import('pages/home'),
    '/': () => import('pages/home'),
    [HOME_ROUTE]: () => import('pages/home'),
    [LISTINGS_ROUTE]: () => import('pages/listings'),
    [SOLUTIONS_ROUTE]: () => import('pages/solutions'),
    [ORGS_ROUTE]: () => import('pages/orgs'),
    [TRIAL_TEMPLATES_ROUTE]: () => import('pages/trialTemplates'),
    [LISTING_EDITOR_ROUTE]: () => import('pages/listingEditor'),
    [PUBLISHER_ROUTE]: () => import('pages/publisher'),
    [LOGGED_OUT_ROUTE]: () => import('pages/loggedout'),
    [ERROR_ROUTE]: () => import('pages/error'),
    [COMMERCE_CALLBACK_ROUTE]: () => import('pages/commerceCallback'),
    [SECURITY_REVIEW_EDITOR_ROUTE]: () => import('pages/securityReviewEditor'),
    [ANALYTICS_ROUTE]: () => import('pages/analytics'),
    '*': () => import('pages/notfound')
  };
} else {
  routes = {
    [MAINTENANCE_ROUTE]: () => import('pages/inMaintenance'),
    '*': () => import('pages/inMaintenance')
  };
}
export const {
  routerStore,
  navigate,
  testIsNavigoLink
} = createRouterStore({
  routes,
  rootUrl: PUBLIC_URL,
  developmentMode: IS_DEVELOPMENT,
  routeLoadDurationCallback: (url, duration) => logger.metric('ept', url, duration)
});

// Scroll to top every time the URL changes
routerStore.subscribe(scrollToTop, selectUrl);
export const WireRouter = createWireStore(routerStore);
initializePageLinks(navigate, testIsNavigoLink);
initializeI18nLinks(navigate, testIsNavigoLink);
export function selectMatch(state) {
  const {
    url,
    queryString,
    hashString,
    data,
    params
  } = state;
  return {
    url,
    queryString,
    hashString,
    data,
    params
  };
}
export function selectQueryAndHashString(state) {
  return {
    queryString: state.queryString,
    hashString: state.hashString
  };
}
export function selectShowInputErrors(state) {
  return state.queryString.includes('showInputErrors');
}
export function selectScrollToQueryParam(state) {
  const queryString = selectQueryString(state);
  if (queryString) {
    return new URLSearchParams(queryString).get('scrollTo');
  }
  return undefined;
}

// Export private members for testing purposes in test env
export const __test__ = process.env.NODE_ENV === 'test' ? {
  routes
} : {};